import React, { useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';
import { FullScreenLoader } from 'components/FullScreenLoader';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuthService } from 'services/auth-service';
import { NotificationService } from 'services/notification-service';
import { ShopifyService } from 'services/shopify-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';

export function ShopifyAuthHandlerPage() {
  const { t } = useTranslation();
  const { shopifyShop, shopUrl } = queryString.parse(location.search);
  const navigate = useNavigate();

  const linkShopifyStoreToUserMutation = useMutation({
    mutationFn: ShopifyService.linkStore,
    onSuccess: () => {
      navigate(ROUTE_LINKS.stores);
      NotificationService.showResult(true, t('FEED_BACK.SHOPIFY.SUCCESS.LINK'));
      ShopifyService.removeShopifyStoreIdFromLocalStorage();
    },
    onError: () => {
      navigate(ROUTE_LINKS.stores);
      NotificationService.showResult(false, t('FEED_BACK.SHOPIFY.FAILURE.LINK'));
      ShopifyService.removeShopifyStoreIdFromLocalStorage();
    }
  });

  useEffect(() => {
    const shopifyShopId =
      typeof shopifyShop === 'string' && shopifyShop.trim() !== ''
        ? shopifyShop
        : ShopifyService.getShopifyStoreIdFromLocalStorage();

    const shopifyShopUrl =
      typeof shopUrl === 'string' && shopUrl.trim() !== ''
        ? shopUrl
        : ShopifyService.getShopifyShopUrlFromLocalStorage();

    if (AuthService.isAuthenticated()) {
      if (shopifyShopId) {
        linkShopifyStoreToUserMutation.mutate(shopifyShopId);
      } else {
        navigate(`${ROUTE_LINKS.stores}`);
      }
    } else {
      if (shopifyShopId && shopifyShopUrl)
        ShopifyService.setShopifyStoreIdToLocalStorage(shopifyShopId, shopifyShopUrl);
      navigate(`${ROUTE_LINKS.signUp}`);
    }
  }, []);

  return <FullScreenLoader />;
}
